import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialBookUpdate from "../social_book_update";
import ReviewHeader from "./review_header";
import ReviewDetails from "./review_details";
import ReviewMetaDetails from "./review_meta_details";
import BookDescription from "../../book_description";
import PreviewBook from "../../preview_book/preview_book";
import { isEmpty, isNull } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "ReviewNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
    }).isRequired,
  },

  // Helper method to determine if review body is present
  reviewBodyPresent() {
    return !isEmpty(this.props.resource.reviewBody);
  },

  // When review body is not present:
  // - Display meta details in book body
  renderBookBody() {
    return (
      <div>
        {
          !this.reviewBodyPresent() ?
            <ReviewMetaDetails readAtText={this.props.resource.readAtText}
              recommendedByUser={this.props.resource.recommendedByUser}/>
            : null
        }
        <BookDescription className="u-marginTopXSmall" bookDescription={this.props.resource.book.description} />
      </div>
    );
  },

  renderReadText(review) {
    return (
      review.readText ?
        <div className="gr-newsfeedItem__readCountText">
          {review.readText}
        </div>
        : null
    );
  },

  render() {
    const review = this.props.resource;
    const header = <ReviewHeader headerText={review.headerText}
                               rating={review.rating}
                               book={this.props.resource.book}
                               reviewBodyPresent={this.reviewBodyPresent()}/>;

    const bookBody = this.renderBookBody();
    let updateDetails = null;

    if (review.reviewBody) {
      updateDetails = <ReviewDetails reviewBody={review.reviewBody}
                                   reviewSpoilerFlag={review.spoilerFlag}
                                   rating={review.rating}
                                   readText={review.readText}
                                   recommendedByUser={review.recommendedByUser}
                                   readAtText={review.readAtText}
                                   reviewUrl={this.props.resourceUrl}
                                   user={review.user}/>;
    }
    else
    {
      updateDetails = this.renderReadText(review);
    }

    return <SocialBookUpdate
      header={header}
      book={this.props.resource.book}
      bookBody={bookBody}
      updateDetails={updateDetails}
      showBookBorder={!isNull(updateDetails)}
      additionalFooterLinks={[<PreviewBook book={this.props.resource.book}/>]}
      {...this.props}
      />;
  },
});
